/**
    * @description      : 
    * @author           : USER
    * @group            : 
    * @created          : 04/09/2025 - 18:59:06
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/09/2025
    * - Author          : USER
    * - Modification    : 
**/
// src/components/ui/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;